import { render, staticRenderFns } from "./CategoryChecklists.vue?vue&type=template&id=8d9c9c58&scoped=true&"
import script from "./CategoryChecklists.vue?vue&type=script&lang=js&"
export * from "./CategoryChecklists.vue?vue&type=script&lang=js&"
import style0 from "./CategoryChecklists.vue?vue&type=style&index=0&id=8d9c9c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9c9c58",
  null
  
)

export default component.exports